import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Search, Plus, Loader, AlertCircle, ChevronDown, ChevronUp } from 'lucide-react';
import API from '../api';
import SchedaCliente from './SchedaCliente';

export default function Clienti() {
  const [cerca, setCerca] = useState('');
  const [risultati, setRisultati] = useState([]);
  const [carico, setCarico] = useState(false);
  const [errore, setErrore] = useState(null);
  const [clienteAperto, setClienteAperto] = useState(null);
  const [mostraFormNuovo, setMostraFormNuovo] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [pagineTotali, setPagineTotali] = useState(1);
  const [totale, setTotale] = useState(0);
  const PER_PAGINA = 25;

  const [ordine, setOrdine] = useState('recenti');
  const cercaClienti = async (p = 1, testo = null, ord = null) => {
    const q = (testo !== null ? testo : cerca).trim();
    const o = ord !== null ? ord : ordine;
    if (!q) return;
    setCarico(true); setErrore(null);
    try {
      const r = await API.get(`/clienti?q=${encodeURIComponent(q)}&pagina=${p}&per_pagina=${PER_PAGINA}&ordine=${o}`);
      setRisultati(r.data.risultati);
      setTotale(r.data.totale);
      setPagineTotali(r.data.pagine_totali);
      setPagina(p);
      if (r.data.totale === 0) setErrore('Nessun cliente trovato.');
    } catch(e) {
      setErrore('Errore nella ricerca.');
    } finally {
      setCarico(false);
    }
  };


  const nomeCliente = (c) => {
    if (c.tipo_cliente === 'azienda') return c.ragione_sociale || '—';
    return `${c.cognome || ''} ${c.nome || ''}`.trim() || '—';
  };

  const sottotitoloCliente = (c) => {
    if (c.tipo_cliente === 'azienda') return `P.IVA ${c.partita_iva || '—'} • ${c.localita || '—'}`;
    return `CF: ${c.codice_fiscale || '—'} • ${c.localita || '—'}`;
  };

  return (
    <div style={{ maxWidth: '100%' }}>
      {/* Barra ricerca */}
      <div style={{ background: 'white', border: '1px solid #e8eaed', borderRadius: 10, padding: 16, marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <input className="input-principale" style={{ flex: 1 }}
            placeholder="Cerca per cognome, nome, codice fiscale o ragione sociale..."
            value={cerca}
            onChange={e => setCerca(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && cercaClienti(1)} />
          <button className="btn-cerca" onClick={() => cercaClienti(1)} disabled={carico}>
            {carico ? <Loader size={16} className="spin" /> : <Search size={16} />}
            Cerca
          </button>
          <button className="btn-cerca" onClick={() => { setMostraFormNuovo(true); setRisultati([]); setErrore(null); }}
            style={{ background: '#276749' }}>
            <Plus size={16} /> Nuovo cliente
          </button>
        </div>
      </div>

      {errore && <div className="alert errore"><AlertCircle size={16} /><span>{errore}</span></div>}

      {/* Form nuovo cliente */}
      {mostraFormNuovo && (
        <div style={{ background: 'white', border: '1px solid #e8eaed', borderRadius: 12, marginBottom: 12, padding: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#276749', marginBottom: 16 }}>
            ➕ Nuovo cliente
          </div>
          <NuovoClienteForm
            onSave={async (dati) => {
              await API.post('/clienti', dati);
              setMostraFormNuovo(false);
              const testoRicerca = dati.cognome || dati.ragione_sociale || '';
              setCerca(testoRicerca);
              await cercaClienti(1, testoRicerca);
            }}
            onCancel={() => setMostraFormNuovo(false)}
          />
        </div>
      )}

      {/* Lista risultati */}
      {risultati.length > 0 && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <div style={{ fontSize: 13, color: '#718096', display: 'flex', alignItems: 'center', gap: 10 }}>
              <span>
                {totale} {totale === 1 ? 'cliente trovato' : 'clienti trovati'}
                {pagineTotali > 1 && ` — pagina ${pagina} di ${pagineTotali}`}
              </span>
              <span style={{ display: 'flex', gap: 4 }}>
                {[['recenti', 'Più recenti'], ['alfabetico', 'A-Z']].map(([val, label]) => (
                  <button key={val}
                    onClick={() => { setOrdine(val); cercaClienti(1, null, val); }}
                    style={{ padding: '2px 10px', borderRadius: 12, fontSize: 12, cursor: 'pointer',
                      fontFamily: 'inherit',
                      border: `1px solid ${ordine === val ? '#2E75B6' : '#dde1e7'}`,
                      background: ordine === val ? '#EBF4FF' : 'white',
                      color: ordine === val ? '#2E75B6' : '#718096',
                      fontWeight: ordine === val ? 600 : 400 }}>{label}</button>
                ))}
              </span>
            </div>
            {pagineTotali > 1 && (
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <button onClick={() => cercaClienti(pagina - 1)} disabled={pagina === 1}
                  style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid #dde1e7',
                    background: pagina === 1 ? '#f7f8fa' : 'white', cursor: pagina === 1 ? 'not-allowed' : 'pointer',
                    fontSize: 13, color: pagina === 1 ? '#a0aec0' : '#1A1A2E' }}>← Precedente</button>
                {Array.from({ length: Math.min(5, pagineTotali) }, (_, i) => {
                  const p = Math.max(1, Math.min(pagina - 2, pagineTotali - 4)) + i;
                  return p <= pagineTotali ? (
                    <button key={p} onClick={() => cercaClienti(p)}
                      style={{ padding: '4px 10px', borderRadius: 6, fontSize: 13, cursor: 'pointer',
                        border: `1px solid ${p === pagina ? '#2E75B6' : '#dde1e7'}`,
                        background: p === pagina ? '#EBF4FF' : 'white',
                        color: p === pagina ? '#2E75B6' : '#1A1A2E',
                        fontWeight: p === pagina ? 600 : 400 }}>{p}</button>
                  ) : null;
                })}
                <button onClick={() => cercaClienti(pagina + 1)} disabled={pagina === pagineTotali}
                  style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid #dde1e7',
                    background: pagina === pagineTotali ? '#f7f8fa' : 'white',
                    cursor: pagina === pagineTotali ? 'not-allowed' : 'pointer',
                    fontSize: 13, color: pagina === pagineTotali ? '#a0aec0' : '#1A1A2E' }}>Successiva →</button>
              </div>
            )}
          </div>
          {risultati.map(c => (
            <div key={c.codice_cliente} style={{
              background: 'white', border: '1px solid #e8eaed', borderRadius: 12,
              marginBottom: 8, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
            }}>
              {/* Header */}
              <div style={{ padding: '12px 20px', display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', cursor: 'pointer' }}
                onClick={() => setClienteAperto(clienteAperto === c.codice_cliente ? null : c.codice_cliente)}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <span style={{ fontSize: 18 }}>{c.tipo_cliente === 'azienda' ? '🏢' : '👤'}</span>
                  <div>
                    <div style={{ fontWeight: 500, fontSize: 14, color: '#1A1A2E' }}>{nomeCliente(c)}</div>
                    <div style={{ fontSize: 12, color: '#718096', marginTop: 2 }}>{sottotitoloCliente(c)}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  {c.email && <span style={{ fontSize: 12, color: '#718096' }}>{c.email}</span>}
                  {clienteAperto === c.codice_cliente
                    ? <ChevronUp size={16} color="#718096" />
                    : <ChevronDown size={16} color="#718096" />}
                </div>
              </div>
              {/* Dettaglio */}
              {clienteAperto === c.codice_cliente && (
                <div style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0', background: '#FAFAFA' }}>
                  <SchedaCliente
                    cliente={c}
                    onAggiornamento={(updated) => {
                      if (updated === null) {
                        setRisultati(prev => prev.filter(x => x.codice_cliente !== c.codice_cliente));
                        setClienteAperto(null);
                      } else {
                        setRisultati(prev => prev.map(x => x.codice_cliente === updated.codice_cliente ? updated : x));
                      }
                    }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Form nuovo cliente ─────────────────────────────────────────────────────────
const LabelInput = ({ label, children, errore }) => (
  <div>
    <div style={{ fontSize: 11, color: '#718096', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
    {children}
    {errore && <div style={{ fontSize: 11, color: '#C53030', marginTop: 2 }}>{errore}</div>}
  </div>
);

// ── Algoritmo Codice Fiscale (decodifica / codifica) ───────────────────────────
function validaCF(cf) {
  if (!cf) return false;
  cf = cf.toUpperCase().trim();
  if (cf.length !== 16) return false;
  const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;
  return regex.test(cf);
}

const CF_MESI = ['A','B','C','D','E','H','L','M','P','R','S','T'];

function decodificaCF(cf) {
  if (!validaCF(cf)) return null;
  cf = cf.toUpperCase().trim();
  const meseChar = cf[8];
  const meseIdx = CF_MESI.indexOf(meseChar);
  if (meseIdx < 0) return null;
  let giorno = parseInt(cf.substring(9, 11), 10);
  let sesso = 'M';
  if (giorno > 40) { sesso = 'F'; giorno -= 40; }
  if (giorno < 1 || giorno > 31) return null;
  const anno2 = parseInt(cf.substring(6, 8), 10);
  const codiceBelfiore = cf.substring(11, 15);
  return { sesso, giorno, mese: meseIdx + 1, anno2, codiceBelfiore };
}

function annoCompletoDaCF(anno2, oggi = new Date()) {
  const annoCorrente = oggi.getFullYear();
  const secolo2000 = 2000 + anno2;
  const secolo1900 = 1900 + anno2;
  return secolo2000 <= annoCorrente ? secolo2000 : secolo1900;
}

function consonantiVocali(s) {
  s = (s || '').toUpperCase().replace(/[^A-Z]/g, '');
  const cons = s.split('').filter(c => !'AEIOU'.includes(c));
  const voc = s.split('').filter(c => 'AEIOU'.includes(c));
  return (cons.join('') + voc.join('') + 'XXX').substring(0, 3);
}

function codiceCognome(cognome) {
  return consonantiVocali(cognome);
}

function codiceNome(nome) {
  nome = (nome || '').toUpperCase().replace(/[^A-Z]/g, '');
  const cons = nome.split('').filter(c => !'AEIOU'.includes(c));
  if (cons.length >= 4) {
    return (cons[0] + cons[2] + cons[3]);
  }
  return consonantiVocali(nome);
}

const CF_PESI_DISPARI = {
  '0':1,'1':0,'2':5,'3':7,'4':9,'5':13,'6':15,'7':17,'8':19,'9':21,
  'A':1,'B':0,'C':5,'D':7,'E':9,'F':13,'G':15,'H':17,'I':19,'J':21,
  'K':2,'L':4,'M':18,'N':20,'O':11,'P':3,'Q':6,'R':8,'S':12,'T':14,
  'U':16,'V':10,'W':22,'X':25,'Y':24,'Z':23,
};
const CF_PESI_PARI = {
  '0':0,'1':1,'2':2,'3':3,'4':4,'5':5,'6':6,'7':7,'8':8,'9':9,
  'A':0,'B':1,'C':2,'D':3,'E':4,'F':5,'G':6,'H':7,'I':8,'J':9,
  'K':10,'L':11,'M':12,'N':13,'O':14,'P':15,'Q':16,'R':17,'S':18,'T':19,
  'U':20,'V':21,'W':22,'X':23,'Y':24,'Z':25,
};
const CF_RESTO_LETTERA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

function carattereControlloCF(quindici) {
  let somma = 0;
  for (let i = 0; i < 15; i++) {
    const ch = quindici[i];
    somma += (i % 2 === 0) ? CF_PESI_DISPARI[ch] : CF_PESI_PARI[ch];
  }
  return CF_RESTO_LETTERA[somma % 26];
}

function codificaCF(cognome, nome, sesso, dataNascita, codiceBelfiore) {
  if (!cognome || !nome || !sesso || !dataNascita || !codiceBelfiore) return null;
  const cCognome = codiceCognome(cognome);
  const cNome = codiceNome(nome);
  const anno2 = String(dataNascita.getFullYear()).slice(-2);
  const meseChar = CF_MESI[dataNascita.getMonth()];
  let giorno = dataNascita.getDate();
  if (sesso === 'F') giorno += 40;
  const giornoStr = String(giorno).padStart(2, '0');
  const quindici = `${cCognome}${cNome}${anno2}${meseChar}${giornoStr}${codiceBelfiore.toUpperCase()}`;
  const controllo = carattereControlloCF(quindici);
  return quindici + controllo;
}

// usato anche dal riquadro "Aggiungi ricorrente" dei collettivi (Collettivi.js), in una modale
export function NuovoClienteForm({ onSave, onCancel }) {
  const [form, setForm] = useState({
    tipo_cliente: 'privato',
    cognome: '', nome: '', codice_fiscale: '',
    data_nascita: '', luogo_nascita: '', provincia_nascita: '', sesso: '',
    convenzione: '',
    ragione_sociale: '', cognome_referente: '', nome_referente: '',
    partita_iva: '', pubblica_amministrazione: false,
    indirizzo: '', cap: '', localita: '', provincia: '',
    telefono: '', telefono2: '', email: '', pec: '', codice_sdi: '', note: ''
  });
  const [errori] = useState({});
  const [carico, setCarico] = useState(false);
  const [convenzioni, setConvenzioni] = useState([]);
  useEffect(() => {
    API.get('/convenzioni').then(r => setConvenzioni(r.data)).catch(() => {});
  }, []);

  const set = useCallback((k, v) => setForm(f => ({ ...f, [k]: v })), []);
  const [risultatiComuneCap, setRisultatiComuneCap] = useState([]);
  const [capOpzioni, setCapOpzioni] = useState([]);
  const cercaComuneCap = async (testo) => {
    set('localita', testo);
    if (testo.trim().length < 2) { setRisultatiComuneCap([]); return; }
    try {
      const r = await API.get(`/comuni-cap/cerca?q=${encodeURIComponent(testo)}`);
      setRisultatiComuneCap(r.data);
    } catch (e) { setRisultatiComuneCap([]); }
  };
  const selezionaComuneCap = (cm) => {
    setForm(f => ({ ...f, localita: cm.denominazione, provincia: cm.provincia || '',
      cap: cm.cap && cm.cap.length === 1 ? cm.cap[0] : '' }));
    setCapOpzioni(cm.cap || []);
    setRisultatiComuneCap([]);
  };
  const isAzienda = form.tipo_cliente === 'azienda';

  const [ricercaComune, setRicercaComune] = useState('');
  const [risultatiComune, setRisultatiComune] = useState([]);
  const [codiceBelfioreNascita, setCodiceBelfioreNascita] = useState(null);
  const [avvisoCf, setAvvisoCf] = useState(null);
  const sincronizzandoDaCf = useRef(false);

  useEffect(() => {
    const decoded = decodificaCF(form.codice_fiscale);
    if (!decoded) return;
    sincronizzandoDaCf.current = true;
    API.get(`/comuni/codice/${decoded.codiceBelfiore}`).then(r => {
      const anno = annoCompletoDaCF(decoded.anno2);
      const dataStr = `${anno}-${String(decoded.mese).padStart(2,'0')}-${String(decoded.giorno).padStart(2,'0')}`;
      setForm(f => ({ ...f, data_nascita: dataStr, luogo_nascita: r.data.denominazione,
        provincia_nascita: r.data.provincia || '', sesso: decoded.sesso }));
      setCodiceBelfioreNascita(decoded.codiceBelfiore);
      setRicercaComune(r.data.denominazione);
      setAvvisoCf(null);
    }).catch(() => {
      setAvvisoCf('Codice del luogo di nascita non riconosciuto.');
    }).finally(() => { sincronizzandoDaCf.current = false; });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.codice_fiscale]);

  useEffect(() => {
    if (sincronizzandoDaCf.current) return;
    if (!form.cognome || !form.nome || !form.sesso || !form.data_nascita || !codiceBelfioreNascita) return;
    const generato = codificaCF(form.cognome, form.nome, form.sesso, new Date(form.data_nascita + 'T00:00:00'), codiceBelfioreNascita);
    if (generato && generato !== form.codice_fiscale) {
      setForm(f => ({ ...f, codice_fiscale: generato }));
      setAvvisoCf('Codice fiscale generato automaticamente: verificarne la correttezza (eventuali omocodie non sono gestite).');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.cognome, form.nome, form.sesso, form.data_nascita, codiceBelfioreNascita]);

  const cercaComune = async (testo) => {
    setRicercaComune(testo);
    if (testo.trim().length < 2) { setRisultatiComune([]); return; }
    try {
      const r = await API.get(`/comuni/cerca?q=${encodeURIComponent(testo)}`);
      setRisultatiComune(r.data);
    } catch (e) { setRisultatiComune([]); }
  };
  const selezionaComune = (comune) => {
    setForm(f => ({ ...f, luogo_nascita: comune.denominazione, provincia_nascita: comune.provincia || '' }));
    setCodiceBelfioreNascita(comune.codice_belfiore);
    setRicercaComune(comune.denominazione);
    setRisultatiComune([]);
  };

  const salva = async () => {
    setCarico(true);
    try {
      const cleanForm = Object.fromEntries(
        Object.entries(form).map(([k, v]) => [k, v === '' ? null : v])
      );
      await onSave(cleanForm);
    } catch(e) {
      console.error(e);
      setCarico(false);
    }
  };

  return (
    <div>
      {/* Tipo */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        {['privato','azienda'].map(t => (
          <button key={t} onClick={() => set('tipo_cliente', t)}
            style={{ padding: '6px 20px', borderRadius: 20, cursor: 'pointer', fontSize: 13,
              border: `1px solid ${form.tipo_cliente === t ? '#2E75B6' : '#dde1e7'}`,
              background: form.tipo_cliente === t ? '#EBF4FF' : 'white',
              color: form.tipo_cliente === t ? '#2E75B6' : '#718096',
              fontWeight: form.tipo_cliente === t ? 600 : 400 }}>
            {t === 'privato' ? '👤 Privato' : '🏢 Azienda'}
          </button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 16 }}>
        {!isAzienda ? (
          <>
            <LabelInput label="Cognome *">
              <input className="input-filtro" style={{ width: '100%' }} value={form.cognome}
                onChange={e => set('cognome', e.target.value)} />
            </LabelInput>
            <LabelInput label="Nome">
              <input className="input-filtro" style={{ width: '100%' }} value={form.nome}
                onChange={e => set('nome', e.target.value)} />
            </LabelInput>
            <LabelInput label="Codice fiscale" errore={errori.codice_fiscale}>
              <input className="input-filtro" style={{ width: '100%' }} value={form.codice_fiscale}
                onChange={e => set('codice_fiscale', e.target.value.toUpperCase())} maxLength={16} />
              {avvisoCf && <div style={{ fontSize: 11, color: '#8E44AD', marginTop: 4 }}>{avvisoCf}</div>}
            </LabelInput>
            <LabelInput label="Data di nascita">
              <input type="date" className="input-filtro" style={{ width: '100%' }}
                value={form.data_nascita} onChange={e => set('data_nascita', e.target.value)} />
            </LabelInput>
            <LabelInput label="Sesso">
              <select className="input-filtro" style={{ width: '100%' }}
                value={form.sesso} onChange={e => set('sesso', e.target.value)}>
                <option value="">— Seleziona —</option>
                <option value="M">M</option>
                <option value="F">F</option>
              </select>
            </LabelInput>
            <LabelInput label="Luogo di nascita">
              <div style={{ position: 'relative' }}>
                <input className="input-filtro" style={{ width: '100%' }}
                  value={ricercaComune} onChange={e => cercaComune(e.target.value)}
                  placeholder="Cerca comune o stato estero..." autoComplete="off" />
                {risultatiComune.length > 0 && (
                  <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 20,
                    background: 'white', border: '1px solid #dde1e7', borderRadius: 6, marginTop: 2,
                    maxHeight: 180, overflowY: 'auto', boxShadow: '0 4px 10px rgba(0,0,0,0.08)' }}>
                    {risultatiComune.map(cm => (
                      <div key={cm.codice_belfiore} onClick={() => selezionaComune(cm)}
                        style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 13 }}
                        onMouseEnter={e => e.currentTarget.style.background = '#F0F7FF'}
                        onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                        {cm.denominazione} {cm.provincia ? `(${cm.provincia})` : ''}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </LabelInput>
            <LabelInput label="Convenzione">
              <select className="input-filtro" style={{ width: '100%' }}
                value={form.convenzione}
                onChange={e => set('convenzione', e.target.value)}>
                <option value="">— Nessuna —</option>
                {convenzioni.map(cv => (
                  <option key={cv.id} value={cv.nome}>{cv.nome}</option>
                ))}
              </select>
            </LabelInput>
          </>
        ) : (
          <>
            <LabelInput label="Ragione sociale *">
              <input className="input-filtro" style={{ width: '100%' }} value={form.ragione_sociale}
                onChange={e => set('ragione_sociale', e.target.value)} />
            </LabelInput>
            <LabelInput label="Partita IVA" errore={errori.partita_iva}>
              <input className="input-filtro" style={{ width: '100%' }} value={form.partita_iva}
                onChange={e => set('partita_iva', e.target.value)} maxLength={11} />
            </LabelInput>
            <LabelInput label="P.A.">
              <select className="input-filtro" style={{ width: '100%' }} value={form.pubblica_amministrazione}
                onChange={e => set('pubblica_amministrazione', e.target.value === 'true')}>
                <option value="false">No</option>
                <option value="true">Sì</option>
              </select>
            </LabelInput>
            <LabelInput label="Cognome referente">
              <input className="input-filtro" style={{ width: '100%' }} value={form.cognome_referente}
                onChange={e => set('cognome_referente', e.target.value)} />
            </LabelInput>
            <LabelInput label="Nome referente">
              <input className="input-filtro" style={{ width: '100%' }} value={form.nome_referente}
                onChange={e => set('nome_referente', e.target.value)} />
            </LabelInput>
          </>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 16 }}>
        <LabelInput label="Indirizzo">
          <input className="input-filtro" style={{ width: '100%' }} value={form.indirizzo}
            onChange={e => set('indirizzo', e.target.value)} placeholder="Via Roma 10" />
        </LabelInput>
        <LabelInput label="Comune">
          <div style={{ position: 'relative' }}>
            <input className="input-filtro" style={{ width: '100%' }}
              value={form.localita}
              onChange={e => cercaComuneCap(e.target.value)}
              placeholder="Cerca comune..." autoComplete="off" />
            {risultatiComuneCap.length > 0 && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 20,
                background: 'white', border: '1px solid #dde1e7', borderRadius: 6, marginTop: 2,
                maxHeight: 180, overflowY: 'auto', boxShadow: '0 4px 10px rgba(0,0,0,0.08)' }}>
                {risultatiComuneCap.map(cm => (
                  <div key={`${cm.denominazione}-${cm.provincia}`} onClick={() => selezionaComuneCap(cm)}
                    style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 13 }}
                    onMouseEnter={e => e.currentTarget.style.background = '#F0F7FF'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                    {cm.denominazione} {cm.provincia ? `(${cm.provincia})` : ''}
                    {cm.cap && cm.cap.length === 1 ? ` — ${cm.cap[0]}` : ''}
                  </div>
                ))}
              </div>
            )}
          </div>
        </LabelInput>
        <LabelInput label="CAP">
          {capOpzioni.length > 1 ? (
            <select className="input-filtro" style={{ width: '100%' }}
              value={form.cap} onChange={e => set('cap', e.target.value)}>
              <option value="">— Seleziona zona —</option>
              {capOpzioni.map(cp => <option key={cp} value={cp}>{cp}</option>)}
            </select>
          ) : (
            <input className="input-filtro" style={{ width: '100%' }} value={form.cap}
              onChange={e => set('cap', e.target.value)} maxLength={5} />
          )}
        </LabelInput>
        <LabelInput label="Provincia">
          <input className="input-filtro" style={{ width: '100%' }} value={form.provincia}
            onChange={e => set('provincia', e.target.value.toUpperCase())} maxLength={2} placeholder="NA" />
        </LabelInput>
        <LabelInput label="Telefono 1">
          <input className="input-filtro" style={{ width: '100%' }} value={form.telefono}
            onChange={e => set('telefono', e.target.value)} />
        </LabelInput>
        <LabelInput label="Telefono 2">
          <input className="input-filtro" style={{ width: '100%' }} value={form.telefono2}
            onChange={e => set('telefono2', e.target.value)} />
        </LabelInput>
        <LabelInput label="Email">
          <input className="input-filtro" style={{ width: '100%' }} value={form.email}
            onChange={e => set('email', e.target.value)} />
        </LabelInput>
        {isAzienda && (
          <LabelInput label="PEC">
            <input className="input-filtro" style={{ width: '100%' }} value={form.pec}
              onChange={e => set('pec', e.target.value)} />
          </LabelInput>
        )}
        {isAzienda && (
          <LabelInput label="Codice SDI">
            <input className="input-filtro" style={{ width: '100%' }} value={form.codice_sdi}
              onChange={e => set('codice_sdi', e.target.value.toUpperCase())} maxLength={7} />
          </LabelInput>
        )}
      </div>

      <LabelInput label="Note">
        <textarea className="input-filtro" style={{ width: '100%', height: 60, resize: 'vertical', marginBottom: 16 }}
          value={form.note} onChange={e => set('note', e.target.value)} />
      </LabelInput>

      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <button className="btn-cerca" style={{ background: '#276749' }} onClick={salva} disabled={carico}>
          {carico ? <Loader size={16} className="spin" /> : null}
          Salva cliente
        </button>
        <button onClick={onCancel} style={{
          padding: '10px 20px', borderRadius: 8, border: '1px solid #dde1e7',
          background: 'white', cursor: 'pointer', fontSize: 14, color: '#718096'
        }}>Annulla</button>
      </div>
    </div>
  );
}
